import {includes, without} from "lodash-es";
import {BsDatepickerConfig, } from "ngx-bootstrap/datepicker";
import {TimepickerComponent} from "ngx-bootstrap/timepicker";
import {Inject, inject, Injectable, Injector, OnInit, ViewChild} from "@angular/core";
import {BsDropdownDirective} from "ngx-bootstrap/dropdown";
import {DatePipe} from "@angular/common";
import {StylableComponent,Parent} from "@wm/components-base";
import {getFormattedDate, runtimeEventManager} from "@wm/core";
import {IWidgetConfig} from "@wm/components-base";
import {getAppDefault} from "./utils/appDefaults";

let projectService :any;
const getWidgetConfig = (WIDGET_CONFIG:any) => {
   projectService = runtimeEventManager.getService('projectService');
  if(projectService.projectDetails.platformType === 'NATIVE_MOBILE'){
    WIDGET_CONFIG.hostClass = without(WIDGET_CONFIG.hostClass.split(' '), 'input-group').join(' ');
    return WIDGET_CONFIG
  }else {
    return WIDGET_CONFIG;
  }

}

@Injectable()
export  abstract class BaseDateTimeComponent extends StylableComponent implements OnInit{

  public required: boolean;
  public disabled: boolean;
  public tabindex: any;
  public name: string;
  public autofocus: boolean;
  public readonly: boolean;
  public placeholder: string;
  public shortcutkey: string;
  public excludedays: string;
  public excludedates: any;
  public outputformat: any;
  public mindate: any;
  public maxdate: any;
  public dataentrymode: any;
  public datepattern: string;
  public timepattern: string;
  public isReadOnly = true;
  public selectfromothermonth: boolean;
  public todaybutton: boolean;
  public clearbutton: boolean;
  public loadNativeDateInput: any;
  public showcustompicker: any;
  public _dateOptions: BsDatepickerConfig = new BsDatepickerConfig();
  protected showseconds: boolean;
  protected ismeridian: boolean;
  protected datePipe: any;
  protected timeNotInRange: boolean;
  protected invalidDateTimeFormat: boolean;
  @ViewChild(BsDropdownDirective) protected bsDropdown: any;
  @ViewChild(TimepickerComponent) protected bsTimePicker: any;
  private validateType: string;


  constructor(inj: Injector, @Inject(Object) WIDGET_CONFIG: IWidgetConfig, viewParent?: Parent) {
    super(inj, getWidgetConfig(WIDGET_CONFIG), viewParent);
    this.datePipe = inject(DatePipe)
    this._dateOptions.todayPosition = 'left';
    this._dateOptions.clearPosition = 'right';
  }

  public override ngOnInit() {
    super.ngOnInit();
    this.loadNativeDateInput =  projectService.projectDetails.platformType === 'NATIVE_MOBILE';
    this.setAppDefaultForProp();
  }

  public updateFormat(pattern: any) {
    if (pattern === 'datepattern' || pattern === 'datetimepattern') {
      this.datepattern = includes(this.datepattern, 'bind:') ? (pattern === 'datepattern' ? getAppDefault('dateFormat') : getAppDefault('dateTimeFormat')) : this.datepattern;
      this._dateOptions.dateInputFormat = this.datepattern;
      this.showseconds = includes(this.datepattern, 's');
      this.ismeridian = includes(this.datepattern, 'h');
    } else if (pattern === 'timepattern') {
      this.timepattern = includes(this.timepattern, 'bind:') ? getAppDefault('timeFormat') : this.timepattern;
      this.showseconds = includes(this.timepattern, 's');
      this.ismeridian = includes(this.timepattern, 'h');
    }
  }

  public invokeOnChange(value: any, $event?: Event | any, valid?: boolean) {

  }

  protected formatValidation(newVal: any, inputVal: any, isNativePicker?: boolean) {
    const pattern = this.datepattern || this.timepattern;
    const formattedDate = getFormattedDate(this.datePipe, newVal, pattern);
    inputVal = inputVal.trim();
    if (inputVal) {
      if (pattern === 'timestamp') {
        if (!isNaN(inputVal) && parseInt(inputVal) !== formattedDate) {
          this.invalidDateTimeFormat = true;
          this.validateType = 'incorrectformat';
          return false;
        }
      } else {
        if (isNativePicker) {
          // format the date value only when inputVal is obtained from $event.target.value, as the format doesnt match.
          inputVal = getFormattedDate(this.datePipe, inputVal, pattern);
        }
        if (inputVal !== formattedDate) {
          this.invalidDateTimeFormat = true;
          this.validateType = 'incorrectformat';
          return false;
        }
      }

    }
    return true;
  }

  setAppDefaultForProp() {}
}
